import { ensureArray } from './utils';

/**
 * Канонические URL каталога по вендору: /solutions/:slug (лучше для SEO, чем ?vendor=).
 */

export function solutionsPathForVendorSlug(slug) {
  if (!slug || typeof slug !== 'string') return '/solutions';
  const s = slug.trim();
  if (!s) return '/solutions';
  return `/solutions/${encodeURIComponent(s)}`;
}

/**
 * @param {string} vendorName
 * @param {Array<{ name?: string, slug?: string }>} vendors
 */
export function solutionsPathForVendorName(vendorName, vendors = []) {
  if (!vendorName || typeof vendorName !== 'string') return '/solutions';
  const t = vendorName.trim();
  if (!t) return '/solutions';
  const v = ensureArray(vendors).find(
    (x) => (x.name || '').trim().toLowerCase() === t.toLowerCase()
  );
  if (v?.slug) return solutionsPathForVendorSlug(v.slug);
  return '/solutions';
}
